<template>
  <div class="page" :style="$store.state.ui.appStyle">
    <div class="topLeft">
      <el-button-group>
        <el-button round size="small" @click="close">
          <el-image style="height: 1.5vh;width: 1.5vh;" :src="require('@/assets/render/svg/close.svg')"></el-image>
        </el-button>
        <el-button round size="small" @click="revert">
          <el-image style="height: 1.5vh;width: 1.5vh;" :src="require('@/assets/render/svg/revert.svg')"></el-image>
        </el-button>
      </el-button-group>
    </div>
    <div class="topCenter">
      <div v-if="!$store.state.ui.os.isPC" style="display: flex;align-items: center;margin-left: -20px;">
        <span class="demonstration" style="font-size: small;flex-shrink: 0;">容差</span>
        <el-slider v-model="shreshold" :min="10" :max="100" style="width: 200px;margin-left: 20px;" />
        <span style="margin-left: 12px;">{{ shreshold }}</span>
      </div>
      <div v-else style="display: flex;align-items: center;margin-left: -70px;">
        <span class="demonstration" style="font-size: small;flex-shrink: 0;">容差</span>
        <el-slider v-model="shreshold" :min="10" :max="100" style="width: 200px;margin-left: 20px;" />
        <span style="margin-left: 12px;">{{ shreshold }}</span>
      </div>
    </div>
    <div class="topRight">
      <el-button round size="small" style="background-color: #ffc343;" @click="done">完成</el-button>
    </div>
    <div class="content" :class="{ 'contentPhone': !$store.state.ui.os.isPC }" :style="{ height: contentHeight }">
      <template v-if="!$store.state.ui.os.isPC">
        <div class="canvasWrapperPhone" style="border-bottom: 4px solid #00000080;">
          <img ref="image" class="picture" />
          <canvas
            ref="canvas"
            class="canvas"
            @mousedown="onMouseDown"
          ></canvas>
        </div>
        <div class="canvasWrapperPhone">
          <canvas
            ref="canvasRight"
            class="canvas"
          ></canvas>
        </div>
      </template>
      <template v-else>
        <div class="canvasWrapper" style="border-Right: 4px solid #00000080;">
          <img ref="image" class="picture" />
          <canvas
            ref="canvas"
            class="canvas"
            @mousedown="onMouseDown"
          ></canvas>
        </div>
        <div class="canvasWrapper">
          <canvas
            ref="canvasRight"
            class="canvas"
          ></canvas>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

let imageInfo
let mask
let cacheInd
let delResData
let hatchOffset = 0
const hatchLength = 4
let source = ''
var interval

export default {
  data () {
    return {
      scale: 1,
      shreshold: 50,
      contentHeight: (window.innerHeight - 110) + 'px'
    }
  },
  methods: {
    getMousePosition (e) {
      let x = Math.floor((e.x - (e.target.parentNode.offsetWidth * 0.5 - e.target.offsetWidth * this.scale * 0.5)) / this.scale)
      let y = Math.floor((e.y - 110 - (e.target.parentNode.offsetHeight * 0.5 - e.target.offsetHeight * this.scale * 0.5)) / this.scale)
      if (x < 0) x = 0
      if (y < 0) y = 0
      if (x > imageInfo.width) x = imageInfo.width
      if (y > imageInfo.width) y = imageInfo.height
      return {
        x: x,
        y: y
      }
    },
    drawMask (x, y) {
      if (!imageInfo) return
      const image = {
        data: imageInfo.data.data,
        width: imageInfo.width,
        height: imageInfo.height,
        bytes: 4
      }
      mask = window.MagicWand.floodFill(image, x, y, this.shreshold)
      this.drawBorder()
    },
    onMouseDown (e) {
      if (e.button === 0) {
        const downPoint = this.getMousePosition(e)
        this.drawMask(downPoint.x, downPoint.y)
        this.imgToCanvas()
      }
    },
    initCanvas (img) {
      if (!this.$refs.image) return
      if (!this.$refs.canvas) return
      if (!this.$refs.canvasRight) return
      this.$refs.image.setAttribute('src', img.src)
      // 固定宽度1024
      const width = 1024
      const height = img.height / img.width * width
      // 获取canvas父容器的尺寸
      const parentWidth = (this.$refs.canvas.parentNode).offsetWidth
      const parentHeight = (this.$refs.canvas.parentNode).offsetHeight
      // img的最大边不超过容器的最小边
      if (img.width >= img.height) {
        this.scale = (Math.min(parentWidth, parentHeight) - 20) / width
      } else {
        this.scale = (Math.min(parentWidth, parentHeight) - 20) / height
      }
      this.$refs.image.style.transform = `scale(${this.scale})`
      this.$refs.canvas.style.transform = `scale(${this.scale})`
      this.$refs.canvasRight.style.transform = `scale(${this.scale})`
      this.$refs.image.style.width = width + 'px'
      this.$refs.image.style.height = height + 'px'
      this.$refs.canvas.width = width
      this.$refs.canvas.height = height
      this.$refs.canvasRight.width = width
      this.$refs.canvasRight.height = height
      const tempCtx = this.$refs.canvasRight.getContext('2d')
      if (!tempCtx) return
      tempCtx.drawImage(img, 0, 0, width, height)
      const data = tempCtx.getImageData(0, 0, width, height)
      imageInfo = {
        width: width,
        height: height,
        context: this.$refs.canvas.getContext('2d'),
        data
      }
    },
    drawBorder (noBorder = false, noFill = false) {
      if (!mask) return
      let x = 0
      let y = 0
      let i = 0
      let j = 0
      let k = 0
      const w = imageInfo.width
      const h = imageInfo.height
      const ctx = imageInfo.context
      const imgData = ctx.createImageData(w, h)
      const res = imgData.data

      if (!noBorder) {
        cacheInd = window.MagicWand.getBorderIndices(mask)
      }

      ctx.clearRect(0, 0, w, h)

      var len = cacheInd.length
      for (let j = 0; j < len; j++) {
        i = cacheInd[j]
        x = i % w // calc x by index
        y = (i - x) / w // calc y by index
        k = (y * w + x) * 4
        if ((x + y + hatchOffset) % (hatchLength * 2) < hatchLength) {
          res[k + 3] = 255 // black, change only alpha
        } else {
          res[k] = 255 // white
          res[k + 1] = 255
          res[k + 2] = 255
          res[k + 3] = 255
        }
      }

      if (noFill) delResData = window.MagicWand.getCurrentResult(mask)
      if (delResData) {
        for (j = 0; j < delResData.length; j++) {
          i = delResData[j]
          x = i % w // calc x by index
          y = (i - x) / w // calc y by index
          k = (y * w + x) * 4
          res[k] = 255 // white
          res[k + 1] = 255
          res[k + 2] = 255
          res[k + 3] = 255
        }
      }
      ctx.putImageData(imgData, 0, 0)
    },
    hatchTick () {
      hatchOffset = (hatchOffset + 1) % (hatchLength * 2)
      this.drawBorder(true)
    },
    load (src) {
      source = src
      const img = new Image()
      img.src = src
      img.onload = () => {
        this.initCanvas(img)
      }
    },
    close () {
      this.$emit('close')
    },
    revert () {
      this.clear()
      this.load(source)
    },
    clear () {
      imageInfo = null
      mask = null
      cacheInd = null
      delResData = null
      window.MagicWand.clearPreData()
    },
    imgToCanvas () {
      const w = imageInfo.width
      const h = imageInfo.height
      const ctx = this.$refs.canvasRight?.getContext('2d')
      if (!ctx) return
      const imageData = ctx.getImageData(0, 0, w, h)
      const res = imageData.data
      const delResData = window.MagicWand.getCurrentResult(mask)
      if (delResData) {
        for (let j = 0; j < delResData.length; j++) {
          const i = delResData[j]
          const x = i % w
          const y = (i - x) / w
          const k = (y * w + x) * 4
          res[k] = 0
          res[k + 1] = 0
          res[k + 2] = 0
          res[k + 3] = 0
        }
      }
      ctx.putImageData(imageData, 0, 0)
    },
    done () {
      if (!this.$refs.canvasRight) return
      // todo: 有1像素白边
      // 去除1像素边框
      const img = new Image()
      const base64 = this.$refs.canvasRight.toDataURL('image/png', 1)
      img.src = base64
      img.onload = () => {
        const canvas = document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height
        const ctx = canvas.getContext('2d')
        if (!ctx) return
        ctx.imageSmoothingQuality = 'high'
        ctx.drawImage(img, 1, 1, img.width - 2, img.height - 2, 0, 0, img.width, img.height)
        const newBase64 = canvas.toDataURL('image/png', 1)
        this.$emit('done', newBase64)
      }
    }
  },
  onUnmounted () {
    clearInterval(interval)
  },
  mounted () {
    interval = setInterval(() => {
      this.hatchTick()
    }, 300)
  }
}
</script>

<style lang="scss" scoped>
.page {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 9999;
  background-color: white;
}
.content {
  width: 100vw;
  margin-top: 110px;
  position: relative;
  display: flex;
  background: #cccccc;
  background-image: linear-gradient(45deg, #f6fafc 25%, transparent 0), linear-gradient(45deg, transparent 75%, #f6fafc 0), linear-gradient(45deg, #f6fafc 25%, transparent 0), linear-gradient(45deg, transparent 75%, #f6fafc 0);
  background-position: 0 0, 10px 10px, 10px 10px, 20px 20px;
  background-size: 20px 20px;
}
.contentPhone {
  flex-direction: column;
}
.uploader {
  position: absolute;
  left: 0;
  top: 0;
  border: 2px dashed #e6e6e6;
  background: url(/image.png) center 93px no-repeat;
  width: 100vw;
  height: 50vh;
  margin: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.canvasWrapper {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.canvasWrapperPhone {
  width: 100%;
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.picture {
  position: absolute;
}
.canvas {
  position: absolute;
  border: 2px solid #00b7ee;
}
.hidden {
  top: -9999px;
}
.topLeft {
  z-index: 998;
  position: absolute;
  top: 0;
  left: 0;
  margin: 15px;
}
.topCenter {
  z-index: 998;
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  margin: 15px;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}
.topRight {
  z-index: 998;
  position: absolute;
  top: 0;
  right: 0;
  margin: 15px;
}
</style>
